export const apis = {
    //For super Admin
    ADMIN: 'admin',
    SWITCH_TO_ADMIN: 'auth/superadmin/login-as-admin',
    BACK_TO_SUPERADMIN: 'auth/superadmin/revert-to-superadmin',

    GET_SUBSCRIPTION: 'subscription',
    PUT_CHANGE_SUBSCRIPTION_STATUS: 'subscription/inactive/',
    GET_TRANSACTION: 'subscription/transaction',
    GET_USERTOKENS: 'chatbot/users-with-tokens',

    GET_DASHBOARD_DATA: 'admin/superadmin-dashboard',
    GET_STRIPE_SETTINGS: 'admin/stripe-settings',
    PUT_STRIPE_SETTINGS: 'admin/stripe-settings',
    GET_STRIPE_PUBLIC_KEY: 'admin/stripe-public-key',

    GET_TRIAL_SETTINGS: 'admin/trial-settings',
    PUT_TRIAL_SETTINGS: 'admin/trial-settings',

    //BOT
    GET_BOT_QNA: 'chatbot/qna',
    GET_BOT_QNA_BY_ID: 'chatbot/find-qna/',
    FIND_BOT_QNA_BY_ID: 'chatbot/find-qna/',
    ADD_BOT_QNA: 'chatbot/add-qna',
    UPDATE_BOT_QNA: 'chatbot/update-qna/',
    DELETE_BOT_QNA: 'chatbot/delete-qna/',
};